<template>
  <div>
    <div>
      <div class="container">
        <page-title
          icon="fa fa-shopping-cart"
          main="Produtos"
          sub="Vincular grupos"
          :help="true" 
          titleHelp="Ajuda - Vincular grupos" 
      content="Página responsável por Vincular grupos
Para criação pressione o botão no canto superior direito 'Novo Grupo'.
Para alteração pressione o botão no canto superior direito 'Editar Grupo'.
Para Vincular selecione o Grupo em 'Selecione o Grupo para Vincular os Sub-Grupos em seguida manipule os vínculos pelos botões localizados no meio da página.'.
"
        >
          <template v-slot:actions>
            <base-button
              type="neutral"
              @click="modals.modal0 = true"
              class="ml-3 mb-2"
              size="sm"
              >Novo Grupo</base-button
            >
            <base-button
              type="neutral"
              @click="modals.modal1 = true"
              class="ml-3 mb-2"
              size="sm"
              >Editar Grupo</base-button
            >
            <base-button
              type="danger"
              @click="modals.modal2 = true"
              class="ml-3 mb-2"
              size="sm"
              >Deletar Grupo</base-button
            >
          </template>
        </page-title>

        <modal :show.sync="modals.modal0" id="cadastrar-gruposgv">
          <template slot="header">
            <h5 class="modal-title" id="exampleModalLabel">
              Cadastrar Grupo SGV
            </h5>
          </template>
          <form role="form" @submit.prevent="handleSubmit(save)">
            <base-input group class="mb-3" :valid="true">
              <input
                type="text"
                class="form-control"
                placeholder="NOME DO GRUPO"
                v-model="gruposgvsave.descricao"
                aria-label="NOME DO GRUPO"
              />
            </base-input>
            <div class="mb-3 codes">
              <multiselect
                :loading="isLoadingErpGroups"
                v-model="gruposgvsave.erp_code"
                @input="getErpCodes"
                placeholder="CÓDIGOS ERP"
                :options="erpGroups"
                :select-label="'Clique para selecionar'"
                :deselect-label="'Item Selecionado'"
                :selected-label="'Selecionado'"
                label="desc_gpr"
                track-by="codi_gpr"
                :allow-empty="true"
                :multiple="true"
                :taggable="true"
              />
            </div>
          </form>
          <template slot="footer">
            <base-button type="secondary" @click="modals.modal0 = false"
              >Fechar</base-button
            >
            <base-button type="success" @click="save">Salvar</base-button>
          </template>
        </modal>
        <modal :show.sync="modals.modal1" id="editar-gruposgv">
          <template slot="header">
            <h5 class="modal-title" id="exampleModalLabel">Editar Grupo SGV</h5>
          </template>
          <form role="form" @submit.prevent="edit">
            <div class="form-group">
              <multiselect
                v-model="gruposgv"
                :options="gruposgvs"
                :select-label="'Clique para selecionar'"
                :deselect-label="'Item Selecionado'"
                :selected-label="'Selecionado'"
                placeholder="Selecione um grupo a ser editado"
                label="descricao"
                track-by="descricao"
                :allow-empty="false"
                :hideSelected="false"
                :close-on-select="true"
                :multiple="false"
                @input="gruposgv.erp_code = parseGroups(gruposgv.erp_codes)"
              >
                <template v-slot:noResult>
                  Nenhum Resultado Encontrado
                </template>
              </multiselect>
              <div
                class="invalid-feedback"
                v-if="!isValidGroup"
                style="display: block;"
              >
                Campo obrigatório
              </div>
            </div>
            <base-input group class="mb-3" :valid="true">
              <input
                type="text"
                class="form-control"
                placeholder="NOME DO GRUPO"
                v-model="gruposgv.descricao"
                aria-label="NOME DO GRUPO"
              />
            </base-input>
            <div class="mb-3 codes">
              <multiselect
                @input="updateGroupsArray(gruposgv, $event)"
                v-model="gruposgv.erp_code"
                placeholder="CÓDIGOS ERP"
                :options="erpGroups"
                label="desc_gpr"
                track-by="codi_gpr"
                :select-label="'Clique para selecionar'"
                :deselect-label="'Item Selecionado'"
                :selected-label="'SelecionadoparseGroups'"
                :multiple="true"
              />
            </div>
          </form>
          <template slot="footer">
            <base-button type="secondary" @click="modals.modal1 = false"
              >Fechar</base-button
            >
            <base-button type="success" @click="edit">Salvar</base-button>
          </template>
        </modal>
        <modal :show.sync="modals.modal2" id="excluir-gruposgv">
          <template slot="header">
            <h5 class="modal-title" id="exampleModalLabel">
              Deletar Grupo SGV
            </h5>
          </template>
          <form role="form" @submit.prevent="remove">
            <multiselect
              v-model="gruposgv"
              :options="gruposgvs"
              placeholder="Selecione o Grupo para vincular os Sub-Grupos"
              label="descricao"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              track-by="descricao"
              :allow-empty="false"
              :hideSelected="false"
              selectLabel="Selecione uma opção para selecionar"
              selectedLabel="Selecionado"
              deselectLabel="Voçê selecionou este item"
              @input="listargrupos"
            >
              <template v-slot:noResult>
                Nenhum Resultado Encontrado
              </template>
            </multiselect>
            <span class="parsley-error" v-if="!isValidGroup"
              >Campo Obrigatório</span
            >
          </form>
          <template slot="footer">
            <base-button type="secondary" @click="modals.modal2 = false"
              >Fechar</base-button
            >
            <base-button type="danger" @click="remove(gruposgv)"
              >Deletar</base-button
            >
          </template>
        </modal>
        <ul>
          <li v-for="(erro, index) of errors" :key="index">
            campo
            <b>{{ erro.field }}</b>
            - {{ erro.defaultMessage }}
          </li>
        </ul>
        <div class="form-row">
          <div class="container">
            <div class="card mt-2">
              <div class="tab-content" id="myTabContent">
                <div
                  :class="index == 0 ? 'tab-pane active' : 'tab-pane fade'"
                  v-for="(gruposgv, index) of gruposgvs"
                  :key="gruposgv.id"
                  v-bind:id="removeAcent(gruposgv.descricao)"
                  role="tabpanel"
                  v-bind:aria-labelledby="
                    removeAcent(gruposgv.descricao) + '-tab'
                  "
                >
                  <div style="padding-bottom: 15px;">
                    <multiselect
                      v-model="filter"
                      :options="gruposgvs"
                      placeholder="Selecione o Grupo para vincular os Sub-Grupos"
                      label="descricao"
                      track-by="descricao"
                      :select-label="''"
                      :deselect-label="''"
                      :selected-label="'Selecionado'"
                      :allow-empty="false"
                      :hideSelected="false"
                      selectLabel="Precione uma opção para selecionar"
                      selectedLabel="Selecionado"
                      deselectLabel="Voçê selecionou este item"
                      @input="listargrupos"
                    >
                      <template v-slot:noResult>
                        Nenhum Resultado Encontrado
                      </template>
                    </multiselect>
                  </div>

                  <template>
                    <vue-list-picker
                      v-on:move-right="adicionaraogrupo(filter.id, $event)"
                      v-on:move-left="adicionaraogrupo(0, $event)"
                      v-on:move-all-right="adicionaraogrupo(filter.id, $event)"
                      v-on:move-all-left="adicionaraogrupo(0, $event)"
                      :left-items="gruposErp"
                      :right-items="rightItems"
                      :content-key="'id'"
                      :content-attr="descricao"
                      :title-left="'SUB-GRUPOS'"
                      :title-right="
                        filter.id ? 'GRUPO ' + filter.descricao : 'GRUPO'
                      "
                      :content-class="'itensGrupos'"
                      :title-class="'tituloGrupos'"
                      :button-class="'btn btn-success button-class'"
                    />
                    <div class="row">
                      <div class="col-md-6 base-pagination-top">
                        <div slot="footer" class="py-4 justify-content-end">
                          <base-pagination
                            v-on:input="changePageLeft"
                            v-model="paginatedErpGroups['current']"
                            :total="paginatedErpGroups['count']"
                            :perPage="paginatedErpGroups['per_page']"
                          ></base-pagination>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div
                          slot="footer"
                          class="py-4 d-flex justify-content-end"
                        >
                          <base-pagination
                            v-on:input="changePageRight"
                            v-model="paginatedErpGroupsRight['current']"
                            :total="paginatedErpGroupsRight['count']"
                            :perPage="paginatedErpGroupsRight['per_page']"
                          ></base-pagination>
                        </div>  
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
// import VueListPicker from "vue-list-picker";
import VueListPicker from "@/components/Vue-list-picker/VueListPicker";
import { showError } from "@/config/msg";
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


// import Permissions from "../users/Permissions";
import Tab from "@/components/Tabs/Tab";
import Tabs from "@/components/Tabs/Tabs";
import TagsInput from "@/components/Inputs/TagsInput";

export default {
  components: {
    PageTitle,
    VueListPicker,
    Permissions,
    Multiselect,
    "tab-pane": Tab,
    Tabs,
    TagsInput,
  },
  name: "app",
  data() {
    const rightItems = [];
    const gruposErp = [];
    return {
      modals: {
        modal0: false,
        modal1: false,
        modal2: false,
      },
      errors: [],
      rightItems,
      itensGrupoSGV: [],
      gruposErp: [],
      gruposgvs: [],
      gruposgv: [],
      gruposgvsave: {},
      filter: { descricao: "Selecione o Grupo para vincular os Sub-Grupos" },
      descricao: "descricao",
      isValidGroup: true,
      paginatedErpGroups: [],
      paginatedErpGroupsRight: [],
      erpGroups: [],

      isLoadingErpGroups: false,
    };
  },
  mounted() {
    this.loadGrupoerp();
    this.loadGruposgvs();
    this.loadErpGroups();
  },
  methods: {
    getErpCodes(object) {
      this.gruposgvsave.erp_codes = object.map((e) => e.codi_gpr.toString());
    },
    parseGroups(codes) {
      console.log("codes: ", codes);

      if (!codes) return [];

      return this.erpGroups.filter((e) =>
        codes.includes(e.codi_gpr.toString())
      );
    },
    updateGroupsArray(object, value) {
      let codesArray = value.map((e) => e.codi_gpr.toString());

      this.$set(object, "erp_codes", codesArray);
    },
    adicionaraogrupo: function (idgruposgv, event) {
      if (event) {
        if (Array.isArray(event)) {
          for (let grupo of event) {
            grupo.grupo = idgruposgv;
            this.$http.secured
              .put(`/api/v1/subgrupos/${grupo.id}`, grupo)
              .then((response) => {
                this.response = response.data;
                this.loadGrupoerp();
              })
              .catch((error) => this.setError(error, "Cannot update "));
          }
        } else {
          event.grupo = idgruposgv;
          this.$http.secured
            .put(`/api/v1/subgrupos/${event.id}`, event)
            .then((response) => {
              this.response = response.data;
              this.loadGrupoerp();
            })
            .catch((error) => this.setError(error, "Cannot update "));
        }
      }
    },
    setError(error, text) {
      this.error =
        (error.response && error.response.data && error.response.data.error) ||
        text;
    },
    loadGruposgvs() {
      this.$http.secured.get("/api/v1/grupos").then((response) => {
        this.gruposgvs = response.data;
      });
    },
    loadGrupoerp(page) {
      if (typeof page == "undefined") page = null;

      this.$http.secured
        .get("/api/v1/gruposfiltrados?grupo=0", {
          params: {
            page: page,
          },
        })
        .then((response) => {
          this.paginatedErpGroups = response.data;
          this.gruposErp = response.data["subgrupos"];
        });
    },
    loadErpGroups() {
      this.isLoadingErpGroups = true;
      this.$http.secured
        .get("/api/v1/grupos", {
          params: { erp_groups: true },
        })
        .then((response) => {
          this.erpGroups = response.data.grupos;
          console.log("Grupos ERP", this.erpGroups);
          this.isLoadingErpGroups = false;
        })
        .catch((this.isLoadingErpGroups = false));
    },
    listargrupos(option, page) {
      if (typeof page == "undefined") page = null;

      this.loadGrupoerp();
      this.$http.secured
        .get(`/api/v1/gruposfiltrados?grupo=${option.id}`, {
          params: {
            page: page,
          },
        })
        .then((response) => {
          this.paginatedErpGroupsRigth = response.data;
          this.rightItems = response.data["subgrupos"];
        });
    },
    removeAcent(text) {
      text = text.toLowerCase();
      text = text.replace(new RegExp("[ÁÀÂÃ]", "gi"), "a");
      text = text.replace(new RegExp("[ÉÈÊ]", "gi"), "e");
      text = text.replace(new RegExp("[ÍÌÎ]", "gi"), "i");
      text = text.replace(new RegExp("[ÓÒÔÕ]", "gi"), "o");
      text = text.replace(new RegExp("[ÚÙÛ]", "gi"), "u");
      text = text.replace(new RegExp("[Ç]", "gi"), "c");
      text = text.toLowerCase();
      return text;
    },
    changePageLeft(page) {
      this.loadGrupoerp(page);
    },
    changePageRight(page) {
      console.log("ID DO OPTIONS: ", this.filter.id);
      this.listargrupos(this.filter, page);
    },

    /*
    save() {
      this.$http.secured
        .post("/api/v1/gruposgvs", { gruposgv: this.gruposgv })
        .then(response => {
          this.gruposgvs.push(response.data);
          this.$toasted.global.defaultSuccess();
          this.modals.modal0 = false;
          this.gruposgv = "";
        })
        .catch(error => this.setError(error, "Cannot save user"));
    },
*/
    save() {
      this.$http.secured
        .post("/api/v1/grupos", { grupo: this.gruposgvsave })
        .then((response) => {
          this.gruposgvs.push(response.data);
          this.loadGruposgvs();
          this.modals.modal0 = false;
          this.gruposgvsave = {};
        })
        .catch((error) => this.setError(error, "Cannot save Group"));
    },
    edit() {
      this.isValidGroup = this.checkGroupValidation(this.gruposgv);
      console.log("VALID GROUP? ", this.isValidGroup);
      if (!this.isValidGroup) return;

      this.$http.secured
        .put(`/api/v1/grupos/${this.gruposgv.id}`, this.gruposgv)
        .then((response) => {
          this.response = response.data;
          this.loadGruposgvs();
          this.gruposgv = {};
          this.modals.modal1 = false;
        })
        .catch((error) => this.setError(error, "Cannot update Group"));
    },
    checkGroupValidation(group) {
      return group.constructor === Object && Object.keys(group).length !== 0;
    },
    remove(gruposgv) {
      if (confirm("Deseja excluir o grupo?")) {
        this.$http.secured
          .delete(`/api/v1/grupos/${gruposgv.id}`, gruposgv)
          .then((response) => {
            this.loadGruposgvs();
            this.$http.secured
              .get(`/api/v1/gruposfiltrados?grupo=${gruposgv.id}`)
              .then((response) => {
                if (response.data) {
                  this.adicionaraogrupo(0, response.data);
                }
              });
            this.gruposgv = [];
            this.modals.modal2 = false;
          })
          .catch((error) => this.setError(error, "Cannot delete todo"));
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.tab-pane {
  padding: 10px;
}
.list-picker-selected {
  background: #61cf8a !important;
}
.button-class {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
  margin-bottom: 10px !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
  min-width: 50% !important;
}

.button-class img {
  filter: invert(100%);
}

.list-picker-container {
  border-width: 10px !important;
  border-color: #f6f6f6 !important;
  background-color: #f6f6f6 !important;
  border-radius: 12px !important;
}

.list-picker-panel {
  border: 1px solid;
  border-color: #ccc;
  border-top: 3px solid;
  border-top-color: #61cf8a;
}

.tituloGrupos {
  background-color: #61cf8a !important;
  box-sizing: border-box !important;
  color: rgb(255, 255, 255) !important;
  display: inline-block !important;
  font-family: Roboto, sans-serif !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  height: 30px !important;
  line-height: 17px !important;
  padding-bottom: 4px !important;
  padding-left: 12px !important;
  padding-right: 12px !important;
  padding-top: 7px !important;
  text-align: left !important;
  text-size-adjust: 100% !important;
  visibility: visible !important;
  width: 100% !important;
  border-radius: 6px 6px 0px 0px;
  border-bottom: 0px !important;
}
/* .multiselect__placeholder {
  color: #adadad !important;
  display: inline-block !important;
  margin-bottom: 10px !important;
  padding-top: 2px !important;
}

.multiselect__input,
.multiselect__single,
.multiselect__tag {
  color: #adadad !important;
  display: inline-block !important;
  margin-bottom: 10px !important;
  padding-top: 2px !important;
  display: none;
} */
/* .multiselect__tag {
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

} */

.codes {
  .multiselect__tags {
    height: auto !important;
  }
}

@media (max-width: 768px) {
  .base-pagination-top{
  position: relative;
  margin-top: -630px;
}
}
</style>
